import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import {
  ADD_UPDATE_HPE_CUSTOMER_REQUEST,
  FETCH_HPE_CUSTOMER_LIST_REQUEST,
} from "./actionTypes";
import {
  addUpdateHPECustomerFailure,
  addUpdateHPECustomerSuccess,
  fetchHPECustomerListFailure,
  fetchHPECustomerListSuccess,
} from "./actions";
import { HPECustomers } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchHPECustomerListSaga(action: any) {
  try {
    const response: HPECustomers[] = yield call(
      postRequest,
      action.url,
      action.payload,
    );

    const totalCount =
      response && response.length > 0 && response[0]?.totalCount
        ? response[0].totalCount
        : 0;
    yield put(fetchHPECustomerListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchHPECustomerListFailure(errorMessage));
  }
}

function* addUpdateHPECustomerSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    yield put(addUpdateHPECustomerSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateHPECustomerFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* HPESaga() {
  yield takeLatest(
    FETCH_HPE_CUSTOMER_LIST_REQUEST,
    fetchHPECustomerListSaga,
  );
  yield takeLatest(
    ADD_UPDATE_HPE_CUSTOMER_REQUEST,
    addUpdateHPECustomerSaga,
  );
}
